// Throws an error if a required argument is missing
export function apiValidateArguments(args) {
  for (const [key, value] of Object.entries(args)) {
    if (value == null) {
      throw new Error(`Missing ${key}.`);
    }
  }
}
